export default {
      id: "ic-down-usage",
      viewBox: "0 0 16 16",
      url: "/" + "images/icons.3.109.2.svg#ic-down-usage",
      toString: function () {
        return this.url;
      }
    }